import React,{useState} from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";


import bg1 from "../assets/images/bg/calendly-background.webp"


import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../utils/scrollUtils";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:FiAirplay,
            title:'Developing strategy',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:LiaReact,
            title:'Blazing performance',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:FiUsers,
            title:'Customer satisfaction',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
    ]
    const counterData = [
        {
            start:'0',
            end:'5458',
            title:'Investment Projects'
        },
        {
            start:'0',
            end:'15',
            title:'Years of Experience'
        },
        {
            start:'0',
            end:'54',
            title:'Offices in the World'
        },
        {
            start:'0',
            end:'214',
            title:'Successful Cases'
        },
    ]

    function CalendlyWidget() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/hello-inclusivefamilyinsurance/30min"
        style={{ minWidth: '320px', height: '1000px' }}
        ></div>
    );
    }

    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

<section id="page-top" className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${bg1})`, backgroundPosition: 'center' }}>
  <div className="bg-overlay bg-gradient-overlay"></div>
  <div className="container">
    <div className="row mt-1 justify-content-center">
      <div className="col-12">
        <div className="title-heading text-center">
          <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">We are here to help.</h5>
          <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">
            A short phone call can make a big difference.
          </small>
        </div>
      </div>
    </div>
    <div className="position-middle-bottom">
      <nav aria-label="breadcrumb" className="d-block">
        <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
          <li className="breadcrumb-item"><Link to="/">Home</Link></li>
          <li className="breadcrumb-item active" aria-current="page">Schedule a call</li>
        </ul>
      </nav>
    </div>
  </div>
</section>

<section className="section pt-0">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12" style={{ maxWidth: '100%' }}>
        {/* Centered Text Above Widget */}
        <p className="text-muted2 text-center mb-0" style={{ fontSize: '1.15rem', fontWeight: 600 }}>
          <br></br>Choose a day below to schedule a call with Scott.
        </p>

        {/* Calendly Widget — full width */}
        <CalendlyWidget />
      </div>
    </div>
  </div>
</section>          
                        
                        
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}